// extracted by mini-css-extract-plugin
export default {"home":"Home_home__PqZOu","homeRight":"Home_homeRight__4LcAR"};